import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  BulkImportCollectorsCsvPreviewResult,
  BulkImportCollectorsCsvResult,
  BulkImportCollectorsResult,
  CollectorsConfig,
  CollectorListItem,
  CollectorListPage,
  CollectorScoreResult
} from '../domain/collector-profile.model';

@Injectable({
  providedIn: 'root'
})
export class CollectorProfileService {
  private readonly baseUrl = environment.API_HOST + '/api/collectors';

  constructor(private http: HttpClient) {}

  listCollectors(
    page: number,
    pageSize: number,
    query?: string
  ): Observable<CollectorListPage> {
    let params = new HttpParams().set('page', page).set('pageSize', pageSize);
    const normalizedQuery = (query ?? '').trim();
    if (normalizedQuery) {
      params = params.set('query', normalizedQuery);
    }
    return this.http.get<CollectorListPage>(this.baseUrl, { params });
  }

  addCollectorByAuth0Id(auth0Id: string): Observable<CollectorListItem> {
    return this.http.post<CollectorListItem>(this.baseUrl, {
      auth0Id
    });
  }

  bulkImportCollectorsByEmails(
    emails: string[]
  ): Observable<BulkImportCollectorsResult> {
    return this.http.post<BulkImportCollectorsResult>(
      `${this.baseUrl}/bulk-import`,
      {
        emails
      }
    );
  }

  bulkImportCollectorsCsv(
    file: File
  ): Observable<BulkImportCollectorsCsvResult> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<BulkImportCollectorsCsvResult>(
      `${this.baseUrl}/bulk-import-csv`,
      formData
    );
  }

  previewBulkImportCollectorsCsv(
    file: File
  ): Observable<BulkImportCollectorsCsvPreviewResult> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<BulkImportCollectorsCsvPreviewResult>(
      `${this.baseUrl}/bulk-import-csv/preview`,
      formData
    );
  }

  exportCollectorsCsv(): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/export-csv`, {
      responseType: 'blob'
    });
  }

  getConfig(): Observable<CollectorsConfig> {
    return this.http.get<CollectorsConfig>(`${this.baseUrl}/config`);
  }

  updateCollector(
    auth0Id: string,
    collectorProfilePatch: Partial<CollectorListItem>
  ): Observable<CollectorListItem> {
    return this.http.put<CollectorListItem>(
      `${this.baseUrl}/${encodeURIComponent(auth0Id)}`,
      collectorProfilePatch
    );
  }

  recalculateScore(auth0Id: string): Observable<CollectorScoreResult> {
    return this.http.post<CollectorScoreResult>(
      `${this.baseUrl}/${encodeURIComponent(auth0Id)}/recalculate-score`,
      {}
    );
  }
}
